import { Box } from "@components/Box/Box";
import { Container } from "@components/Container/Container";
import { Icon } from "@components/Icon/Icon";
import { Module } from "@components/Module/Module";
import React, { useRef, useState } from "react";
import styles from "./styles.module.scss";
import plusIcon from "@svg-icons/plus.component.svg";
import classNames from "classnames";
import anime from "animejs";
export interface RichtextProps {
  richtext: string;
  expandActive?: boolean;
}

const Richtext: React.FC<RichtextProps> = props => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const expandButton = useRef<HTMLButtonElement>(null);
  const expandContainer = useRef<HTMLDivElement>(null);

  const expand: React.MouseEventHandler<HTMLButtonElement> = e => {
    e.preventDefault();

    const scrollHeight = expandContainer.current?.scrollHeight;

    anime({
      targets: expandContainer.current,
      height: [300, scrollHeight],
      duration: 500,
      easing: "easeInQuart",
      complete: () => {
        if (expandContainer.current) {
          expandContainer.current.style.height = "auto";
        }
      }
    });

    anime({
      targets: expandButton,
      opacity: [1, 0],
      duration: 200,
      easing: "easeInQuart",
      complete: () => {
        setExpanded(true);
      }
    });
  };

  return (
    <Module animate>
      <Container variant="small" smallpad>
        <div
          ref={expandContainer}
          className={classNames(
            styles.richtext,
            props.expandActive && styles.expandActive,
            expanded && styles.expandActiveNotactive
          )}
          dangerouslySetInnerHTML={{ __html: props.richtext }}
        />
        {props.expandActive && !expanded && (
          <Box className={styles.expandButtonContainer}>
            <button
              ref={expandButton}
              onClick={expand}
              className={styles.expandButton}
            >
              <Icon svg={plusIcon} />
            </button>
          </Box>
        )}
      </Container>
    </Module>
  );
};
export { Richtext };
